import React, { useEffect, useState } from "react";
import CookieConsentBar from "../components/cookieconsentbar";
import { initScrollTracking } from "../tracking/scroll-tracking";
import { useLang } from "../contexts/LangContext";

export default function AppShell({ children }) {
  const { lang } = useLang();

  const [consent, setConsent] = useState(null);

  /**
   * 1. INIT CONSENT STATE (safe + reset-proof)
   */
  useEffect(() => {
    const saved = localStorage.getItem("cookie-consent");

    if (saved === "accepted" || saved === "denied") {
      setConsent(saved);
    } else {
      setConsent("unknown");
      localStorage.removeItem("cookie-consent");
    }
  }, []);

  /**
   * 2. SYNC CONSENT NAAR GA (consent mode)
   */
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!window.gtag) return;
    if (!consent || consent === "unknown") return;

    window.gtag("consent", "update", {
      analytics_storage: consent === "accepted" ? "granted" : "denied",
    });

    localStorage.setItem("cookie-consent", consent);
  }, [consent]);

  /**
   * 3. SCROLL TRACKING (alleen bij accept)
   */
  useEffect(() => {
    if (consent !== "accepted") return;

    const cleanup = initScrollTracking();
    return () => cleanup?.();
  }, [consent]);

  /**
   * 4. COOKIE BAR HANDLER
   */
  const handleConsent = (value) => {
    setConsent(value); // "accepted" | "denied"
  };

  const showCookieBar = consent === "unknown";

  return (
    <>
      {children}

      {showCookieBar && (
        <CookieConsentBar onClose={handleConsent} lang={lang} />
      )}
    </>
  );
}